import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlugAndPlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 58,
	viewBox: "0 0 42 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1262_21464)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4 17.4199L4 43.4199H27V17.4199H4Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18 42.4199V48.4199H8V42.4199",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1 14.4199L1 40.4199H24V14.4199H1Z",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13 48.4199V50.2699C13 53.6699 15.75 56.4199 19.15 56.4199H30.84C34.24 56.4199 36.99 53.6699 36.99 50.2699V29.4199",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31 27.4199H42",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33 23.4199V16.4199H40V23.4199",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 5.41992V7.41992",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16 5.41992V7.41992",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21 11.4199V1.41992H4V11.4199",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1 33.4199H23",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1262_21464",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 42,
			height: 57,
			fill: "white",
			transform: "translate(0 0.419922)"
		})
	}) })]
});
export default SvgPlugAndPlay;
